/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
import * as tslib_1 from "tslib";
import { Subscriber } from '../Subscriber';
export function isEmpty() {
  return function (source) {
    return source.lift(new IsEmptyOperator());
  };
}
var IsEmptyOperator = /*@__PURE__*/function () {
  function IsEmptyOperator() {}
  IsEmptyOperator.prototype.call = function (observer, source) {
    return source.subscribe(new IsEmptySubscriber(observer));
  };
  return IsEmptyOperator;
}();
var IsEmptySubscriber = /*@__PURE__*/function (_super) {
  tslib_1.__extends(IsEmptySubscriber, _super);
  function IsEmptySubscriber(destination) {
    return _super.call(this, destination) || this;
  }
  IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
    var destination = this.destination;
    destination.next(isEmpty);
    destination.complete();
  };
  IsEmptySubscriber.prototype._next = function (value) {
    this.notifyComplete(false);
  };
  IsEmptySubscriber.prototype._complete = function () {
    this.notifyComplete(true);
  };
  return IsEmptySubscriber;
}(Subscriber);